import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { NgxVcardModule } from 'ngx-vcard';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSelectModule } from '@angular/material/select'
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbar, MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatList, MatListModule } from '@angular/material/list';
import { MatPaginatorModule} from '@angular/material/paginator';
import { AppComponent } from './app.component';
import { UserProfileComponent } from './profile/user-profile/user-profile.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { EditUserProfileComponent } from './profile/edit-user-profile/edit-user-profile.component';
import { NavBarMobileComponent } from './nav-bar/nav-bar-mobile/nav-bar-mobile.component';
import { AddDirectReportComponent } from './profile/edit-user-profile/add-direct-report/add-direct-report.component';
import { AddEditPhoneDeviceComponent } from './profile/edit-user-profile/add-edit-phone-device/add-edit-phone-device.component';
import { ConfirmPromptComponent } from './helper/confirm-prompt/confirm-prompt.component';
import { PhonePipe } from './helper/pipe/phone.pipe';
import { AddUserComponent } from './admin/add-user/add-user.component';
import { EditUserPhotoComponent } from './profile/edit-user-photo/edit-user-photo.component';
import { StylePaginatorDirective } from './style-paginator.directive';
import { UserHistoryComponent } from './search/user-history/user-history.component';
import { SsoComponent } from './sso/sso/sso.component';
import { MsalModule, MsalService, MsalGuard, MsalInterceptor, MsalBroadcastService, MsalRedirectComponent } from "@azure/msal-angular";
import { PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from "@azure/msal-browser";
import { StatusBarModule } from 'src/modules/components/status-bar/status-bar.module';
import { StatusBarService } from 'src/services/status-bar-service';
import { UserSearchComponent } from './search/user-search/user-search.component';
import { environment } from 'src/environments/environment';
import { ContactListComponent } from './contact-list/contact-list.component';
import { ValidateEditprofileComponent } from './profile/validate-editprofile/validate-editprofile.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { provideServiceWorker } from '@angular/service-worker';
import { DirectreportComponent } from './directreport/directreport.component';
import { MatTabsModule } from '@angular/material/tabs';
import { DeptempschedulereportComponent } from './deptempschedulereport/deptempschedulereport.component';

import { MatExpansionModule } from '@angular/material/expansion';
import { ErrorComponent } from './helper/error/error.component';
import { AdminpanelComponent } from './adminpanel/adminpanel.component';


import { providePrimeNG } from 'primeng/config';
import { ColorPickerModule } from 'primeng/colorpicker';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { PhonelistreportComponent } from './phonelistreport/phonelistreport.component';



export const protectedResourceMap = new Map([ 
  ['https://graph.microsoft.com/v1.0/me/', ['user.read']]

]);

// export const protectedResourceMap = new Map([ 
//   ['https://graph.microsoft.com/v1.0/me', ['user.read']],
//   [ environment.baseUrl + '/*', ['customscope.read']]
// ]);
const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;
@NgModule({ declarations: [
        AppComponent,
        UserProfileComponent,
        NavBarComponent,
        EditUserProfileComponent,
        NavBarMobileComponent,
        AddDirectReportComponent,
        AddEditPhoneDeviceComponent,
        ConfirmPromptComponent,
        PhonePipe,
        AddUserComponent,
        EditUserPhotoComponent,
        StylePaginatorDirective,
        UserHistoryComponent,
        UserSearchComponent,
        SsoComponent,
        ContactListComponent,
        DirectreportComponent,
        DeptempschedulereportComponent,
        ErrorComponent,
        AdminpanelComponent,
        PhonelistreportComponent
    ],
    bootstrap: [AppComponent, MsalRedirectComponent], imports: [BrowserModule,
        StatusBarModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        NgxVcardModule,
        MatCardModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatGridListModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatToolbarModule,
        MatTooltipModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatTableModule,
        MatDialogModule,
        MatCheckboxModule,
        MatListModule,
        MatPaginatorModule,
        MatTableModule,
        MatTabsModule,
        MatIconModule,
        MatExpansionModule,
        ColorPickerModule,
        MsalModule.forRoot(new PublicClientApplication({
            auth: {
                clientId: "e26cd79e-c9e9-4e5f-8c51-456506bf1adc",
                authority: "https://login.microsoftonline.com/96b9695c-4f0e-42bd-8adf-ba755760346b",
                redirectUri: environment.redirectUrl,
            },
            cache: {
                cacheLocation: BrowserCacheLocation.LocalStorage,
            },
            system: {
                loggerOptions: {
                    loggerCallback: (logLevel: LogLevel, message: string) => {
                        //
                    },
                    piiLoggingEnabled: false
                }
            }
        }), {
            interactionType: InteractionType.Redirect, // MSAL Guard Configuration
        }, {
            interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration,
            protectedResourceMap: protectedResourceMap
        }),
        ], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        
        provideServiceWorker('ngsw-worker.js', {
            enabled: environment.production, // true in prod
            registrationStrategy: 'registerWhenStable:30000', // optional
        }),
        MsalService,
        MsalGuard,
        StatusBarService,
        MsalBroadcastService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }